/*
 * slider/index.js
 *
 * This file contains the default setup for slick slider and provides a method to initlise new carousels
 *
 */
import $ from 'jquery';
import 'slick-carousel';

// Create slick carousel on the passed in element and option values
function createSlider(element, customOpts) {
    const $sliderContainer = $(element).children('.slider-container');
    const $slider = $(element).find('.inner');

    // Early return if the slider is already initialised, no need to do it again
    if ($slider.hasClass('slick-initialized')) {
        return;
    }

    // GS FED Boilerplate default options for the slider, best not change these!
    const slickDefaults = {
        appendArrows: $sliderContainer,
        appendDots: $sliderContainer,
        dots: true,
        speed: 300,
        prevArrow: '<button type="button" role="button" class="slick-prev slick-arrow"><svg class="svg-icon"><use xlink:href="#chevron-left" /></svg><span>Previous</span></button>',
        nextArrow: '<button type="button" role="button" class="slick-next slick-arrow"><span>Next</span> <svg class="svg-icon"><use xlink:href="#chevron-right" /></svg></button>',
        ...customOpts
    };

    $slider.slick(slickDefaults);
}

function initSliders() {
    const $slides = $('.c-slider');

    // Init all the sliders on the page one at a time
    $slides.each(function () {
        if (this.classList.contains('autoplay')) {
            createSlider(this, { autoplay: true, autoplaySpeed: 3000 });
        } else {
            createSlider(this);
        }

        // Make slider arrow position relative to the image inside the slider
        const $imageWrapper = $(this).find('.slider-image-container, .tile-image-wrapper');
        const $arrow = $(this).find('.slick-arrow');

        const positionArrows = () => {
            if ($imageWrapper.length) {
                const imageWrapperHeight = $imageWrapper[0].offsetHeight;

                const arrowTop = imageWrapperHeight / 2;
                $arrow.css('top', `${arrowTop}px`);
            }
        };

        // Call positionArrows after a small delay on resize
        let resizeTimeout;
        $(window).on('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(positionArrows, 100);
        });

        positionArrows();
    });
}

// Run the functions on document ready
$(() => initSliders());
